"use client";

import { ArrowsDownUp } from "@repo/ui/components/icons";
import { useRouter } from "next/navigation";

// Sorting is a query-string view (noindex, canonical on the clean path), so
// the options arrive as ready-made hrefs from the server.
export function SortSelect({ options, value }: { options: { value: string; label: string; href: string }[]; value: string }) {
  const router = useRouter();
  return (
    <label className="bg-background flex shrink-0 items-center gap-1.5 rounded-full py-1.5 ps-3 pe-2 text-sm shadow-sm">
      <ArrowsDownUp size={16} className="text-muted-foreground" />
      <span className="sr-only">مرتب‌سازی</span>
      <select
        value={value}
        onChange={(event) => {
          const option = options.find((o) => o.value === event.target.value);
          if (option) router.push(option.href, { scroll: false });
        }}
        className="cursor-pointer bg-transparent pe-1 outline-none"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
